module.exports = "#version 300 es\nprecision highp float;\n\nuniform vec3 u_Eye, u_Ref, u_Up;\nuniform vec2 u_Dimensions;\nuniform float u_Time;\n\nin vec2 fs_Pos;\nout vec4 out_Col;\n\nconst vec3 colors[3] = \nvec3[](\n  vec3(0.91, 0.85, 1.0),\n  vec3(0.13, 0.09, 0.18),\n  vec3(0.4, 0.3, 0.56));\n\nvoid main() {\n  vec2 uv = gl_FragCoord.xy / u_Dimensions.xy;\n  //out_Col = vec4(0.5 * (fs_Pos + vec2(1.0)), 0.0, 1.0);\n  out_Col = vec4(0.31, 0.20, 0.40, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/flat-frag.glsl
// module id = 78
// module chunks = 0